// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608240646/js/" + chunkId + "." + {"44":"53a7d2da","225":"38c5e9fd","481":"3d4798ec","486":"88f67416","770":"bb2cd6ce"}[chunkId] + ".0.18146506234716175.chunk.js";
};